/**
 * All Pinia store state is persisted to local storage via the Pinia Persisted State Plugin.
 * This plugin makes sure that stale data is removed after a certain time of inactivity.
 */
export default defineNuxtPlugin(() => {
    if (safeLocalStorage.isLocalStorageAccessible()) {
        if (!safeLocalStorage.getItem('tot_last_interaction')) {
            try {
                safeLocalStorage.setItem('tot_last_interaction', new Date().toISOString());
            }
            catch (error) {

            }
        }
        const lastInteraction = Date.parse(safeLocalStorage.getItem('tot_last_interaction') ?? '');
        if (Number.isNaN(lastInteraction)) {
            return;
        }

        // Expiry is an elapsed duration, so it does not depend on a timezone.
        // Native timestamps also work in webviews that cannot subclass Date correctly.
        const diff = Date.now() - lastInteraction;
        const diffInMinutes = diff / 1000 / 60;
        const EXPIRY_IN_MINUTES = 60;

        if (diffInMinutes > EXPIRY_IN_MINUTES) {
            logSentryBreadcrumb('Clear expired LocalStorage!');
            safeLocalStorage.clear();
        }
    }
});
